// extracted by mini-css-extract-plugin
export default {"root":"GlobalErrorPopUp_root__XSWiE","title":"GlobalErrorPopUp_title__h9P6h","description":"GlobalErrorPopUp_description__qYIxj","btn":"GlobalErrorPopUp_btn__P14C7"};